import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { Task } from '../../../../../_shared/model';
import { MfToastService, StorageService } from '../../../../../_shared/services';
import { TaskService } from '../../_services';
import { HelperService } from './../../../../../_shared/services/helper.service';

@Component({
    selector: 'app-index-tasks',
    templateUrl: './index-tasks.component.html',
    styleUrls: ['./index-tasks.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class IndexTasksComponent implements OnInit {
    public allTasks: Observable<Task[]>;

    // public page: number = 1;
    public currentPage = 1;
    public itemsPerPage = 8;

    // @ViewChild('myTable') table;
    constructor(
        private taskRest: TaskService,
        private storage: StorageService,
        private toast: MfToastService,
        private route: Router,
        public helper: HelperService,
    ) {}

    ngOnInit() {
        this.allTasks = this.taskRest.getContractorTasks(_.get(this.storage.getSelectedContractor(), 'id', -1));
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public concludeTask(row: any): void {
        if (row) {
            this.taskRest.concludeTask(this.storage.getSelectedContractor().id, row.id).subscribe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                res => {
                    if (row.status === 1) {
                        row.status = 2;
                        this.toast.success('Opravilo zaključeno');
                    } else {
                        row.status = 1;
                        this.toast.success('Opravilo vrnjeno v izvajanje');
                    }
                },
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                error => {
                    this.toast.error('Napaka pri zaključevanju opravila');
                },
            );
        }
        return;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
    public onSelect(event: any): void {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onActive(event: any): void {
        if (event.type === 'click') {
            if (event.column.prop === 'status') {
                event.event.stopPropagation();
            } else {
                if (event.row) {
                    if (event.row.customerId) {
                        this.route.navigate(['/customers/view', event.row.customerId]);
                    }
                }
            }
        }
    }
}
